import { useSelector } from "react-redux";
import { selectTheme } from "@/store/store";
import useCustomTranslation from "@/hooks/use-custom-translation";

export default function Logo() {
  const { t } = useCustomTranslation();
  const theme = useSelector(selectTheme);

  const isDark =
    theme === "dark" ||
    (theme === "system" &&
      window.matchMedia("(prefers-color-scheme: dark)").matches);

  const logoConfig = {
    full: isDark
      ? "/logos/studexam/studexam-logo-full-white.png"
      : "/logos/studexam/studexam-logo-full.png",
    compact: isDark
      ? "/logos/studexam/studexam-logo-white.png"
      : "/logos/studexam/studexam-logo.png",
    textColor: isDark ? "text-gray-300" : "text-gray-600",
  };

  return (
    <div className="@container w-full relative">
      <img
        src={logoConfig.full}
        alt="StudExam Logo"
        className="w-48 h-auto hidden @[50px]:block mx-auto"
      />

      <img
        src={logoConfig.compact}
        alt="StudExam Logo"
        className="w-48 h-auto block @[50px]:hidden mx-auto"
      />

      <div
        className={`absolute bottom-0 translate-y-[70%] translate-x-4 right-0 items-center gap-0 text-xs ${logoConfig.textColor} hidden @[50px]:flex`}
      >
        <span>{t("common.by")}</span>

        <img
          src="/logos/mister-prepa-white-logo.png"
          alt="Mister Prepa Logo"
          className="h-16 w-auto invert dark:invert-0"
        />
      </div>
    </div>
  );
}
